var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoAddHedgeRecipient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "32px",
    viewBox: "0 0 38 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 31") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1042.000000, -881.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(1043.000000, 882.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19-Copy",
    transform: "translate(10.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,17 C1.20631119,16.3669541 3.95521288,14.1937341 4.7854198,13.237915 C5.59125512,12.3101551 2.90461696,11.4267155 2.03114734,8.92602539 C0.79616539,5.39034762 1.6189445,0.129772798 7.49318348,0",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2770996,24.9227295 C15.2359294,24.9227295 14.2072072,25.017816 11.1350098,24.7190961 M7.5,18.0567627 C9.3380127,16.3812256 13.1241455,15.477417 15.0693359,13.237915 C15.8751713,12.3101551 13.1885331,11.4267155 12.3150635,8.92602539 C11.0800815,5.39034762 11.9028606,0.129772798 17.7770996,0",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    transform: "translate(12.638550, 12.468559) scale(-1, 1) translate(-12.638550, -12.468559) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(12.500000, 16.500000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 Z M5.9,6 L2.7,6 L2.7,8.1328125 L5.9,8.1328125 L5.9,11.3152344 L8.0328125,11.3152344 L8.0328125,8.1328125 L11.3152344,8.1328125 L11.3152344,6 L8.0328125,6 L8.0328125,2.7 L5.9,2.7 L5.9,6 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(0.000000, 17.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-96",
    points: "19.0166016 0 19.0166016 12.3152344 6.82292622e-13 12.3152344 6.82292622e-13 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-97",
    points: "0 0 9.50830078 7 19.0166016 0"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAddHedgeRecipient);
export default __webpack_public_path__ + "static/media/ico_add-hedge-recipient.489f21e1dcd5e23e84b6001855c1dc80.svg";
export { ForwardRef as ReactComponent };